import {useTranslation} from '@aboutyou/i18n';
import React, {FC, useState} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {GenericFilteredItems} from '../../FilterContent/Shared/GenericFilteredItems/GenericFilteredItems';
import {GenericFilterItemGroup} from '../../FilterContent/Shared/GenericFilteredItems/types';
import {GenericFilterSearchField} from '../../FilterContent/Shared/GenericSearchField';
import {FilterFlyout, Sections} from '../FilterFlyout';
import {FilterFlyoutFooter} from '../FilterFlyoutFooter';

interface Props {
  hide: VoidFunction;
  submit: VoidFunction;
  isOpen: boolean;
  label: string;
  activeIds: Array<string>;
  itemGroups: Array<GenericFilterItemGroup>;
  onItemClick: (itemId: string, itemSlug?: string) => void;
  renderInPortal?: boolean;
  enableFilterFlyout?: boolean;
}

export const FilterFlyoutSearch: FC<Props> = ({
  hide,
  isOpen,
  label,
  activeIds,
  itemGroups,
  onItemClick,
  renderInPortal,
  enableFilterFlyout = true,
  submit,
}) => {
  const [search, setSearch] = useState('');
  const {t} = useTranslation();

  const handleClose = () => {
    setSearch('');
    hide();
  };

  const handleSubmit = () => {
    setSearch('');
    submit();
  };

  return (
    <StyledFilterFlyout
      footer={FilterFlyoutFooter}
      onPrimaryButtonClick={handleSubmit}
      onSecondaryButtonClick={handleClose}
      primaryButtonLabel={t('Submit')}
      secondaryButtonLabel={t('Back')}
      onClose={handleClose}
      open={isOpen}
      title={label}
      renderInPortal={renderInPortal}
    >
      <SearchFieldWrapper>
        <GenericFilterSearchField
          search={search}
          setSearch={setSearch}
          showDoneButton={true}
          searchPlaceholder={t('Search for brands')}
        />
      </SearchFieldWrapper>
      <StyledGenericFilteredItems
        search={search}
        activeIds={activeIds}
        itemGroups={itemGroups}
        onItemClick={onItemClick}
        enableFilterFlyout={enableFilterFlyout}
      />
    </StyledFilterFlyout>
  );
};

const StyledFilterFlyout = styled(FilterFlyout)`
  ${Sections} {
    padding: 0;
  }
`;

const SearchFieldWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: ${COLORS['Fill.White']};
  padding: 16px 16px 0 16px;
`;

const StyledGenericFilteredItems = styled(GenericFilteredItems)`
  padding-inline: 16px;
  height: calc(100vh - 4rem - 4rem - 5rem - 4vh - 80px);
  /* 100vh - top space - header height - footer height - top flyout margin - search field height */
`;
